import cn from 'classnames';

/**
 * A simple utility function to get the dynamic collapser styles.
 */
export default function getCollapserStyles(_ref) {
  var _ref2;
  var flipped = _ref.flipped,
    suffix = _ref.suffix,
    suffixFlipped = _ref.suffixFlipped;
  for (var _len = arguments.length, classNames = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    classNames[_key - 1] = arguments[_key];
  }
  return cn.apply(undefined, ['md-collapser', (_ref2 = {
    'md-collapser--flipped': flipped && (!suffixFlipped || !suffix)
  }, _ref2['md-collapser--' + suffix] = suffix, _ref2['md-collapser--' + suffix + '-flipped'] = suffix && flipped && suffixFlipped, _ref2)].concat(classNames));
}